export default __webpack_public_path__ + "static/RIOT-3ddab8a0944ba67f7a7d8c9207e962b2.svg";